import LoginService from "../../api/LoginService";
import RootType from "../../store/mutation-types";
import { EServiceStatusConfig } from "../../enum/EStatus";
export default {
    data: function () {
        var data = {
            loginService: ''
        };
        return data;
    },
    created: function () {
        this.loginService = LoginService.getInstance();
    },
    methods: {
        getOpenedEdiStatus: function () {
            var _this = this;
            this.loginService.getOpenedEdiStatus().then(function (res) {
                if (res.data.success) {
                    var data = res.data.data;
                    console.info('data', data);
                    var edi_status = ((data && data.edi_status == 1) ? true : false);
                    _this.$store.commit(RootType.UPDATE_EDI_STATUS, edi_status);
                    _this.$store.commit(RootType.UPDATE_CAN_SELECT_BATCH, data.is_delivery_manual_batch);
                    _this.$store.commit(RootType.UPDATE_CAN_SEND_EMAIL, data.is_send_purchase_mail);
                }
                else {
                    _this.$message.error(res.data.msg || "获取第三方分拣参数失败");
                }
            });
        },
        getOpenedCode: function () {
            var _this = this;
            this.loginService.getOpenedCode().then(function (res) {
                if (res.data.success) {
                    var data = res.data.data;
                    _this.$store.commit(RootType.UPDATE_OPENED_CODE_DATA, {
                        isOpenSorting: data.indexOf(EServiceStatusConfig.sorting) !== -1,
                        isOnlyOpenERP: data.indexOf(EServiceStatusConfig.sorting) == -1 && data.indexOf(EServiceStatusConfig.erp) !== -1,
                        isOpenERP: data.indexOf(EServiceStatusConfig.erp) !== -1,
                        isOrderService: data.indexOf(EServiceStatusConfig.xdfw) !== -1,
                        isOpenTAQ: data.indexOf(EServiceStatusConfig.zzsy) !== -1,
                        isOpenMultOrg: data.indexOf(EServiceStatusConfig.multOrg) !== -1,
                        isOpenInterMall: data.indexOf(EServiceStatusConfig.interMall) !== -1,
                        isOpenThirdSystem: data.indexOf(EServiceStatusConfig.thirdSystem) !== -1,
                    });
                }
                else {
                    _this.$message.error(res.data.msg || "获取开启服务编号失败");
                }
            }, function (err) {
                _this.$message.error(err.message || "请求报错");
            });
        },
        getConfig: function (supId) {
            var _this = this;
            this.loginService.getConfig({ supplier_id: supId }).then(function (res) {
                if (res.data.success) {
                    var data = res.data.data;
                    var config = {
                        is_apply_auth: data.is_apply_auth,
                        is_admin: data.is_admin,
                        company_name: data.company_name
                    };
                    _this.$store.commit(RootType.UPDATE_CONFIG, Object.assign({}, config));
                }
                else {
                    _this.$message.error(res.data.msg || "获取认证状态失败");
                }
            }, function (err) {
                _this.$message.error(err.message || "请求报错");
            });
        }
    }
};
